export default __webpack_public_path__ + "static/media/wf-isf-expanded-goals-body1-mobile.08ce896f.jpg";